import { useMutation, UseMutationResult } from 'react-query'

import api from 'api/index'
import { ApiError } from '../types/ApiError'

const deleteDemo = (id: string): Promise<void> => api.delete(`/demos/${id}`)

export const useDeleteDemo = (): UseMutationResult<void, ApiError, string> => useMutation((id) => deleteDemo(id))
